/* Honeypot */
// document.getElementById("Form_ContactForm_Password_Holder").style.display = 'none';

var form_msg = document.querySelectorAll("#Form_ContactForm_error.good, #Form_ContactForm_error.bad")

if (form_msg.length > 0) {
    document.getElementsByClassName("footer-contact")[0].scrollIntoView();
}

document.addEventListener('DOMContentLoaded', function () {
    let scrollEl = document.getElementById('siteScroller');
    if (scrollEl) {
        let images = scrollEl.getElementsByClassName('image');

        for (let i = 0; i < 2; i++) {
            let tempImg = images[i].cloneNode(true);
            tempImg.classList.remove('first');
            scrollEl.append(tempImg);
        }

        var imgs = document.querySelectorAll(".case-study img")
        for (i = 0; i < imgs.length; i++) {
            imgs[i].style.marginBottom = -imgs[i].offsetHeight / 2 + 'px'
        }
    }
}, false);

const FloatLabel = (() => {
    // add active class and placeholder
    const handleFocus = (e) => {
        console.log('FOCUSED');
        const target = e.target;
        target.parentNode.parentNode.classList.add('active');
    };

    // remove active class and placeholder
    const handleBlur = (e) => {
        const target = e.target;
        if (!target.value) {
            target.parentNode.parentNode.classList.remove('active');
        }
    };

    // register events
    const bindEvents = (element) => {
        const floatField = element.querySelector('.middleColumn input, .middleColumn textarea');
        floatField.addEventListener('focus', handleFocus);
        floatField.addEventListener('blur', handleBlur);
    };

    // get DOM elements
    const init = () => {
        const floatContainers = document.querySelectorAll('.field');

        floatContainers.forEach((element) => {
            var el = element.querySelector('.middleColumn input, .middleColumn textarea');
            if (el != null && el.value != '') {
                // element.parentNode.classList.add('active');
                element.classList.add('active');
            }
            if (el != null) {
                bindEvents(element);
            }
        });
    };

    return {
        init: init
    };
})();


function loadScript(url, callback) {
    var script = document.createElement("script")
    script.type = "text/javascript";
    if (script.readyState) {  // only required for IE <9
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

if (document.getElementById('bg-fog')) {
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/three.js/r121/three.min.js', function () {
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/vanta/0.5.22/vanta.fog.min.js', function () {
            VANTA.FOG({
                el: "#bg-fog",
                mouseControls: true,
                touchControls: true,
                gyroControls: false,
                minHeight: 200.00,
                minWidth: 200.00,
                highlightColor: 0x00aeef,
                midtoneColor: 0x00aeef,
                lowlightColor: 0x00aeef,
                baseColor: 0x8e57fc,
                blurFactor: 0.48,
                speed: 2.90,
                zoom: 1.30,
            })
        })
    })
}

FloatLabel.init();


document.addEventListener('mousemove', function (event) {
    var windowWidth = window.innerWidth,
        windowHeight = window.innerHeight,
        mouseXpercentage = Math.round(event.pageX / windowWidth * 100),
        mouseYpercentage = Math.round(event.pageY / windowHeight * 100),
        targets = document.querySelectorAll('.radial-gradient,.footer-radial-gradient')
    if (windowWidth >= 900) {
        for (var i = 0; i < targets.length; i++) {
            targets[i].style.background = 'radial-gradient(at ' + mouseXpercentage + '% ' + mouseYpercentage + '%, #00aeef, #8e57fc)'
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    let collapsibleContentSections = document.querySelectorAll('.collapsible-content-section');
    if (collapsibleContentSections.length) {
        getFolding();
    }
});

function getFolding() {
    let sections = document.querySelectorAll('.collapsible-content-section');

    sections.forEach(function (section) {
        let sectionContent = section.querySelector('.section-content');
        section.classList.remove('unfold');

        section.addEventListener('click', function () {
            if (section.classList.contains('unfold')) {
                section.classList.remove('unfold');
            } else {
                // Close any open sections
                sections.forEach(function (section) {
                    section.classList.remove('unfold');
                });
                //Unfold current section
                section.classList.add('unfold');
            }
        });
    });
}
